import { useEffect, useState } from "react";
import { Star, Quotes } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function TestimonialsSection() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section data-testid="testimonials-section" className="py-20 md:py-32 px-6 md:px-12 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-12 items-end mb-16">
          <div className="md:col-span-7">
            <span className="overline text-[#E63946]">Avis clients</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0D2C54] tracking-tight">
              Ils nous font confiance.
            </h2>
          </div>
          <div className="md:col-span-5 flex items-center gap-6">
            <div>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={22} weight="fill" className="text-[#E63946]" />
                ))}
              </div>
              <div className="mt-1 text-sm text-[#555555]">4,9 / 5 sur Google · 240+ avis</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E7EB]">
          {items.map((t) => (
            <div
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className="bg-white p-8 md:p-10 group hover:bg-[#F8F9FA] transition-colors"
            >
              <Quotes size={28} className="text-[#E63946]" weight="fill" />
              <p className="mt-6 text-[#333333] leading-relaxed">"{t.comment}"</p>
              <div className="mt-8 pt-6 border-t border-[#E5E7EB] flex items-center justify-between">
                <div>
                  <div className="font-display font-semibold text-[#0D2C54]">{t.name}</div>
                  <div className="text-xs text-[#555555] mt-1">{t.vehicle}</div>
                </div>
                <div className="flex">
                  {[...Array(t.rating)].map((_, i) => (
                    <Star key={i} size={14} weight="fill" className="text-[#E63946]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
